<template>
  <section class="listing">
    <div class="header">
      <div class="title">Festivais</div>
      <button @click="$router.push('/festival/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <form @submit.prevent class="form form-search">
      <!-- <date-picker v-model="period" @change="getData" type="date" range placeholder="Selecione um período" format="DD/MM/YYYY"></date-picker> -->
      <div class="search-input">
        <input v-model="search" type="text" placeholder="Pesquisar..." />
        <i class="fas fa-search show-search"></i>
      </div>
      <!-- <label class="switch" style="margin: 5px">
        <input @change="getData" v-model="canceled" type="checkbox">
        <span class="slider"></span>
        <span class="text">Cancelados</span>
      </label> -->
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div v-for="(festival) in filteredFestivals" :key="festival.id" class="list">
          <div class="data">
            <div class="main-data">{{ festival.name }}</div>
          </div>
          <div class="actions">
            <button v-if="festival.shortUrl" @click="share = festival" type="button" class="button-action" style="margin-right: 5px"><i class="fas fa-share"></i><span>COMPARTILHAR</span></button>
            <button @click="$router.push(`/festival/${festival.id}`)" type="button" class="button-action">
              <i class="fas fa-pen"></i><span>ALTERAR</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
    <Festival v-if="!loading && festival" :id="festival" />
    <ShowShare v-if="share" :show="share" :close="() => this.share = null" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getAll } from '../api/festival'
import Festival from './Festival.vue'
import ShowShare from './ShowShare.vue'

export default {
  name: 'festivals',
  components: { Festival, ShowShare },
  props: ['id'],
  data () {
    return {
      loading: true,
      festival: null,
      festivals: [],
      period: [],
      search: '',
      share: null
    }
  },
  computed: {
    ...mapState(['business']),
    filteredFestivals () {
      return this.festivals.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {
    async '$route' (value) {
      this.festival = value.name === 'festival-id' ? value.params['id'] : null
      // Update list
      if (!value.params['id']) {
        this.getData()
      }
    },
    validation (value) {
      if (!value) {
        this.getData()
      }
    }
  },
  async mounted () {
    try {
      this.period = []
      this.period.push(new Date())
      this.period.push(new Date(new Date().setDate(new Date().getDate() + 30)))
      this.getData()
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        this.festivals = await getAll()
      } catch (error) {
        logger.warn(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.list-title {
  border: 1px solid $primary-color;
  border-radius: 5px;
  // color: $primary-color;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  color: #fff;
  padding: 5px 10px;
  margin: 15px 0 5px;
}

.form-search {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  padding-bottom: 10px;

  .search-input input {
    width: 100%;
    height: 34px;
    margin: 5px;
  }

  .search-input {
    flex: 1;
    min-width: 200px;
    position: relative;
    margin: 5px;
    input {
      display: block;
      width: 100%;
      margin: 0;
    }
    i {
      position: absolute;
      top: 6px;
      right: 10px;
      color: #999;
      font-size: 1.5em;
    }
  }
}

.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  padding-right: 20px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

@media screen and (min-width: $desktop-width) {

  .form-search {
    input {
      width: auto;
    }
  }

}
</style>
